<template lang="pug">
span.copy-text(translate="no" @click.stop="doCopy")
    slot
    Teleport(to="body")
        span.copy-toast(v-if="show" :style="toastStyle") Copied!
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue';

const props = defineProps<{ value: string }>();

const show = ref(false);
const toastStyle = reactive({ top: '0px', left: '0px' });
let timer: ReturnType<typeof setTimeout> | null = null;

const doCopy = (e: MouseEvent) => {
    navigator.clipboard.writeText(props.value).catch(() => {
        const ta = document.createElement('textarea');
        ta.value = props.value;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        ta.remove();
    });

    toastStyle.left = e.clientX + 'px';
    toastStyle.top = (e.clientY - 28) + 'px';

    if (timer) clearTimeout(timer);
    show.value = true;
    timer = setTimeout(() => { show.value = false; }, 1200);
};
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

.copy-text {
    display: inline;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }

    &.overflow {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>

<style lang="less">
@import "@/assets/less/bq-tokens.less";

/* Ink on paper, inverted with the theme: dark bubble with white text on the
   light scheme, light bubble with dark text on the dark scheme. A hardcoded
   #333 background left the paper-coloured text unreadable in dark mode. */
.copy-toast {
    position: fixed;
    transform: translateX(-50%);
    background: @ink;
    color: @paper;
    border: 1px solid @ink;
    box-shadow: 2px 2px var(--bq-shadow);
    font-size: 0.7rem;
    font-family: @mono;
    padding: 2px 8px;
    white-space: nowrap;
    pointer-events: none;
    z-index: 99999999;
    animation: copyFadeIn 0.15s ease;
}

@keyframes copyFadeIn {
    from { opacity: 0; transform: translateX(-50%) translateY(4px); }
    to { opacity: 1; transform: translateX(-50%) translateY(0); }
}
</style>
